// @flow
import React, { Component } from "react";
import { connect } from "react-redux";
import { bindActionCreators } from "redux";

import { hasPrincipal } from "../../../global/containers/UserAuth";
import FacebaseItem from "../../components/facebases/FacebaseItem";

type FacebaseItemReduxPropsType = {
  facebase: { [key: string]: * },
  company: { [key: string]: * },
  isAdmin?: boolean,
  user: { [key: string]: * }
};

class FacebaseItemRedux extends Component<FacebaseItemReduxPropsType, *> {
  render(): React$Element<*> {
    const isFacebaseAdmin = hasPrincipal(
      "facebase-admin",
      this.props.user.groups
    );

    return (
      <FacebaseItem
        facebase={this.props.facebase}
        company={this.props.company}
        isAdmin={this.props.isAdmin}
        isFacebaseAdmin={isFacebaseAdmin}
      />
    );
  }
}

const mapStateToProps = (state: StateType): * => ({
  user: state.v3account.user
});

export default connect(mapStateToProps)(FacebaseItemRedux);
